export default "__VITE_ASSET__XQ4WkZnw__"